import {AddressModel, ApplicantModel, CollateralModel, CustomerConsentModel, EmploymentModel, ResidenceModel} from '@service/models';

export class CreateApplicationModel {
    loanPurposeConfig: any;
    applicant: ApplicantModel;
    address: AddressModel;
    otherApplicants?: ApplicantModel[];
    memberExist?: string;
    membershipEligibility?: string;
    affiliatedSponsorOrganization?: any;
    residence?: ResidenceModel;
    employment?: EmploymentModel;
    collateral?: CollateralModel;
    consents?: CustomerConsentModel[];
    ioBlackBox?: any;
    socureSessionId?: string;
    socureDeviceSessionId?: string;
    gliaSiteId?: string;
    selectedSubProducts?: any;
}

export class SelectedProductModel {
    product: Object|any = undefined;
    subProduct: Object|any = undefined;
    additionalFeatures: Array<Object|any> = [];
    selectedSubProducts?: any;
}
